// ==============================|| OVERRIDES - TAB ||============================== //

export default function Select(theme) {
  return {
    MuiSelect: {
      styleOverrides: {
        root: {
          '& .Mui-required .MuiFormLabel-asterisk': {
            color: theme.palette.error.main,
            fontWeight: 700
          }
        }
      }
    }
  };
}